/**
 * 转场特效 - camera 0.5s + 0.25s + 0.5s 先固定相对位置，然后旋转半径并拉远
 * 2018-10-8
 */
(function (root, factory) {
  if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = factory(this);
  } else {
      factory(root);
  }
})(this, function (root) {
  // 类构造函数
  function con(scene, option) {
    this.code = option.code || 'CameraUp';
  }

  // 方法
  var methods = {
    init: function () {
      this.duration = 1.25; // 动效持续时间
      this.startAt = 0.75; // 开始时间（场景结束前n秒）

      return this.supr(this.startAt).then(function () {
      });
    },

    initDom: function () {
      var sele = this.scene.element.player,
        h = this.scene.editor.clientHeight,
        w = this.scene.editor.clientWidth;
      sele.css({
        transform: 'scale(1) rotateX(0deg) translateY(0) translateZ(0)',
        transformOrigin: '0px 0px 0px',
        transformStyle: 'preserve-3d',
        filter: 'none'
      });

      if (this.nexts) {
        var nexts_ele = this.nexts.element.player;
        nexts_ele.css({
          transformOrigin: '0px 0px 0px',
          transformStyle: 'preserve-3d',
          filter: 'none'
        });
        switch (this.code) {
          case 'CameraUp':
            nexts_ele.css({
              transform: 'rotateX(-30deg) translate3d(0px,' + (-h - 100) + 'px,100px)'
            });
            break;
          case 'CameraDown':
            nexts_ele.css({
              transform: 'rotateX(30deg) translate3d(0px,' + (100 + h) + 'px,100px)'
            });
            break;
          case 'CameraLeft':
            nexts_ele.css({
              transform: 'rotateY(30deg) translate3d(' + (-w - 100) + 'px,0px,300px)'
            });
            break;
          case 'CameraRight':
            nexts_ele.css({
              transform: 'rotateY(-30deg) translate3d(' + (w + 100) + 'px,0px,300px)'
            });
            break;
        }
      }
    },

    show: function (frame) {
      // 播放
      if (!this.isInit) return;
      this.supr(frame);

      var scene = this.scene,
        editor = scene.editor,
        sele = scene.element.player, // plyaer层的当前scene,
        h = editor.clientHeight,
        w = editor.clientWidth,
        firstPart = 0.5*this.frameRate,     // 前30帧线性变化
        middlePart = 0.25*this.frameRate,    // 中间15帧不变
        z = -1400;        // 最远点

      editor.player.ele.show();
      sele.show();


      // 前750ms
      if (frame <= this.entrance.end) {
        this.showFirst(frame)
      }

      // 后750ms
      if (this.nexts && frame >= this.exit.start) {
        // 隐藏上一个场景页的遮罩
        this.prevs && this.prevs.effect.maskEle && this.prevs.effect.maskEle.hide();

        var nexts_ele = this.nexts.element.player; // player层中的下一个场景
        var offframe = frame - this.exit.start;

        nexts_ele.show();
        editor.player.ele.css({
          background: '#FFF',
          transformStyle: 'preserve-3d',
          perspective: '600px',
        });

        if (offframe < firstPart) {
          switch (this.code) {
            case 'CameraUp':
              sele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(' + this.linear(offframe, 1, -0.5, firstPart) + ')',
                transform: 'rotateX(' + this.linear(offframe, 0, 15, firstPart) +'deg) translateY(' + this.linear(offframe, 0, 0.25*w-250, firstPart)
                  + 'px) translateZ(' + this.linear(offframe, 0, z, firstPart) + 'px)'
              });
              nexts_ele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(' + this.linear(offframe, 1, -0.5, firstPart) + ')',
                transform: 'rotateX(' + this.linear(offframe, -30, 15, firstPart) +'deg) translateY(' + this.linear(offframe, -h - 100, -0.25*w+h + 350, firstPart)
                  + 'px) translateZ(' + this.linear(offframe, 100, z-100, firstPart) + 'px)'
              });
              break;
            case 'CameraDown':
              sele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(' + this.linear(offframe, 1, -0.5, firstPart) + ')',
                transform: 'rotateX(' + this.linear(offframe, 0, -15, firstPart) +'deg) translateY(' + this.linear(offframe, 0, 250-0.25*w, firstPart)
                  + 'px) translateZ(' + this.linear(offframe, 0, z, firstPart) + 'px)'
              });
              nexts_ele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(' + this.linear(offframe, 1, -0.5, firstPart) + ')',
                transform: 'rotateX(' + this.linear(offframe, 30, -15, firstPart) +'deg) translateY(' + this.linear(offframe, h + 100, 0.25*w-h - 350, firstPart)
                  + 'px) translateZ(' + this.linear(offframe, 100, z-100, firstPart) + 'px)'
              });
              break;
            case 'CameraLeft':
              sele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(' + this.linear(offframe, 1, -0.5, firstPart) + ')',
                transform: 'rotateY(' + this.linear(offframe, 0, -15, firstPart)
                  +'deg) translateX(' + this.linear(offframe, 0, 0.45*w-200, firstPart)
                  + 'px) translateZ(' + this.linear(offframe, 0, z, firstPart) + 'px)'
              });
              nexts_ele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(' + this.linear(offframe, 1, -0.5, firstPart) + ')',
                transform: 'rotateY(' + this.linear(offframe, 30, -15, firstPart)
                  +'deg) translateX(' + this.linear(offframe, -w - 100, 350+0.55*w, firstPart)
                  + 'px) translateZ(' + this.linear(offframe, 300, z-300, firstPart) + 'px)'
              });
              break;
            case 'CameraRight':
              sele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(' + this.linear(offframe, 1, -0.5, firstPart) + ')',
                transform: 'rotateY(' + this.linear(offframe, 0, 15, firstPart)
                  + 'deg) translateX(' + this.linear(offframe, 0, 200-0.45*w, firstPart)
                  + 'px) translateZ(' + this.linear(offframe, 0, z, firstPart) + 'px)'
              });
              nexts_ele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(' + this.linear(offframe, 1, -0.5, firstPart) + ')',
                transform: 'rotateY(' + this.linear(offframe, -30, 15, firstPart)
                  + 'deg) translateX(' + this.linear(offframe, w+100, (-0.55*w-300), firstPart)
                  + 'px) translateZ(' + this.linear(offframe, 0, z, firstPart) + 'px)'
              });
              break;
          }
        } else if (offframe >= firstPart) {
          switch (this.code) {
            case 'CameraUp':
              sele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(0.5)',
                transform: 'rotateX(15deg) translateY(' + 0.25*w-250 + 'px) translateZ(' + z +'px)'
              });
              nexts_ele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(0.5)',
                transform: 'rotateX(-15deg) translateY(' + 250-0.25*w + 'px) translateZ(' + z +'px)'
              });
              break;
            case 'CameraDown':
              sele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(0.5)',
                transform: 'rotateX(-15deg) translateY(' + 250 - 0.25 * w + 'px) translateZ(' + z +'px)'
              });
              nexts_ele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(0.5)',
                transform: 'rotateX(15deg) translateY(' + 0.25 * w - 250 + 'px) translateZ(' + z +'px)'
              });
              break;
            case 'CameraLeft':
              sele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(0.5)',
                transform: 'rotateY(-15deg) translateX(' + 0.45*w-200 + 'px) translateZ(' + z +'px)'
              });
              nexts_ele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(0.5)',
                transform: 'rotateY(15deg) translateX(' + 200-0.45*w + 'px) translateZ(' + z +'px)'
              });
              break;
            case 'CameraRight':
              sele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(0.5)',
                transform: 'rotateY(15deg) translateX(' + 200 - 0.45 * w + 'px) translateZ(' + z +'px)'
              });
              nexts_ele.css({
                transformOrigin: '50% 50% 0px',
                filter: 'brightness(0.5)',
                transform: 'rotateY(-15deg) translateX(' + 0.45 * w - 200 + 'px) translateZ(' + z +'px)'
              });
              break;
          }
        }
      }

      // 动画区间外，隐藏其它元素，恢复位置
      if (frame > this.entrance.end && frame < this.exit.start) {
        this.showMiddle();

      }
    },

    showNext: function (frame) {
      var scene = this.scene,
        editor = scene.editor,
        sele = scene.element.player; // plyaer层的当前scene

      var next_ele = this.nexts.element.player;

      var _currentFrame = this.startAt * this.frameRate + frame - 0.75 * this.frameRate,
        lastPart = 0.5*this.frameRate, // 最后30帧线性变化
        z = -1400,
        h = editor.clientHeight,
        w = editor.clientWidth;

      editor.player.ele.css({
        background: '#FFF',
        transformStyle: 'preserve-3d',
        perspective: '600px',
      });

      sele.css({
        transformOrigin: '50% 50% 0px',
        filter: 'brightness(' + this.linear(_currentFrame, 0.5, 0.5, lastPart) + ')'
      });
      next_ele.css({
        transformOrigin: '50% 50% 0px',
        filter: 'brightness(' + this.linear(_currentFrame, 0.5, 0.5, lastPart) + ')'
      });

      switch (scene.effect.code) {
        case 'CameraUp':
          sele.css({
            transform: 'rotateX(' + this.linear(_currentFrame, 15, -15, lastPart)
              + 'deg) translateY(' + this.linear(_currentFrame, 0.25*w-250, 2000, lastPart)
              + 'px) translateZ(' + this.linear(_currentFrame, z, 100-z, lastPart) + 'px)'
          });
          next_ele.css({
            transform: 'rotateX(' + this.linear(_currentFrame, -15, 15, lastPart)
              + 'deg) translateY(' + this.linear(_currentFrame, 250-0.25*w, 0.25*w-250, lastPart)
              + 'px) translateZ(' + this.linear(_currentFrame, z, -z, lastPart) + 'px)'
          });
          break;
        case 'CameraDown':
          sele.css({
            transform: 'rotateX(' + this.linear(_currentFrame, -15, 15, lastPart)
              + 'deg) translateY(' + this.linear(_currentFrame, 250-0.25*w, -2000, lastPart)
              + 'px) translateZ(' + this.linear(_currentFrame, z, 100-z, lastPart) + 'px)'
          });
          next_ele.css({
            transform: 'rotateX(' + this.linear(_currentFrame, 15, -15, lastPart)
              + 'deg) translateY(' + this.linear(_currentFrame, 0.25*w-250, 250-0.25*w, lastPart)
              + 'px) translateZ(' + this.linear(_currentFrame, z, -z, lastPart) + 'px)'
          });
          break;
        case 'CameraLeft':
          sele.css({
            transform: 'rotateY(' + this.linear(_currentFrame, -15, 15, lastPart)
              + 'deg) translateX(' + this.linear(_currentFrame, 0.45*w-200, 2000, lastPart)
              + 'px) translateZ(' + this.linear(_currentFrame, z, 300-z, lastPart) + 'px)'
          });
          next_ele.css({
            transform: 'rotateY(' + this.linear(_currentFrame, 15, -15, lastPart)
              + 'deg) translateX(' + this.linear(_currentFrame, 200-0.45*w, 0.45*w-200, lastPart)
              + 'px) translateZ(' + this.linear(_currentFrame, z, -z, lastPart) + 'px)'
          });
          break;
        case 'CameraRight':
          sele.css({
            transform: 'rotateY(' + this.linear(_currentFrame, 15, 15, lastPart)
              + 'deg) translateX(' + this.linear(_currentFrame, 200-0.45*w, -2000, lastPart)
              + 'px) translateZ(' + this.linear(_currentFrame, z, 300-z, lastPart) + 'px)'
          });
          next_ele.css({
            transform: 'rotateY(' + this.linear(_currentFrame, -15, 15, lastPart)
              + 'deg) translateX(' + this.linear(_currentFrame, 0.45*w-200, 200-0.45*w, lastPart)
              + 'px) translateZ(' + this.linear(_currentFrame, z, -z, lastPart) + 'px)'
          });
          break;
      }
    }
  }

  // 静态方法
  var statics = {

  }

  if (root.AnimEditor) {
    root.AnimEditor.extendScenesEffect('Camera', con, methods, statics);
    return;
  }

  return function (AnimEditor) {
    AnimEditor.extendScenesEffect('Camera', con, methods, statics);
  }
});


//////////////////
// WEBPACK FOOTER
// ./static/animengine/js/scene-effects/se-camera.js
// module id = NkyR
// module chunks = 16